import { useTranslations } from 'next-intl';

import EmptyStateVisual from '@/components/shared/EmptyStateVisual';
import { cn } from '@/utils/cn';

interface Props {
  isCompactSize?: boolean;
  className?: string;
}

export default function EmptyGamesState({ className, isCompactSize }: Props) {
  const t = useTranslations('lobby.filters');

  return (
    <div className={cn('relative isolate flex flex-col items-center mb-6.5 lg:mb-5 lg:gap-0.5 lg:mt-4.75 gap-2', className)}>
      <EmptyStateVisual isCompactSize={isCompactSize} />
      <p className="text-white font-regular text-[1rem] max-lg:-mt-2.25 leading-6 text-center lg:font-regular lg:text-lg tracking-[-0.001em] lg:leading-7">
        {t.rich('we-couldnt-find-the-game-youre-looking-for', {
          br: () => <span className="lg:hidden"><br /></span>,
        })}
      </p>
    </div>
  );
}
